<label [attr.for]="formControlName" class="form-label {{isRequired()?'required':''}}">{{ label }}</label>
<input
    currencyMask
    type="text"
    class="form-control"
    [id]="formControlName"
    [formControl]="control"
    [readonly]="isReadOnly"
    placeholder="R$ 0,00"
    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', allowNegative : negativo }"
    [tabindex]="isReadOnly?'-1':tabindex"
    [autocomplete]="autoComplete"
    (click)="start()">
<form-field-error [form-control]="control"></form-field-error>